import { Inject, ModelEvents } from '@denishussar/html5-game-engine';
import {
    ConfirmationsBuyEmbroideryController,
    IConfirmationsBuyEmbroideryControllerOptions,
} from './ConfirmationsBuyEmbroideryController';
import { GameModel } from '../../../Models/GameModel';
import {CrazyGamesAdsLogic} from "../../../Logic/CrazyGames/CrazyGamesAdsLogic";
import {AdsLogic} from "../../../Logic/Ads/AdsLogic";

export class ConfirmationsBuyCoinsOnlyEmbroideryController extends ConfirmationsBuyEmbroideryController {
    public constructor(
        @Inject _options: IConfirmationsBuyEmbroideryControllerOptions,
        @Inject _modelEvents: ModelEvents,
        @Inject adsLogic: AdsLogic,
        @Inject _model: GameModel,
    ) {
        super(_options, _modelEvents, adsLogic, _model);
    }

    onInitialize(): void {
        super.onInitialize();

        const buy_embroidery_receive = this.$childControllers.get('buy_embroidery_receive');
        if (buy_embroidery_receive) {
            buy_embroidery_receive.visible = false;
        }

        const buy_embroidery_buy = this.$childControllers.get('buy_embroidery_buy');
        if (buy_embroidery_buy) {
            buy_embroidery_buy.display.position.x = 0;
        }
    }
}
